import { useState } from 'react';

export type ComponentStatus = 'idle' | 'error' | 'loading' | 'success';

/**
 * Hook for common status handling.
 */
export const useComponentStatus = (initialState: ComponentStatus = 'idle') => {
  const [status, setStatus] = useState<ComponentStatus>(initialState);
  const isLoading = status === 'loading';
  const hasError = status === 'error';
  const isIdle = status === 'idle';
  const isSucceeded = status === 'success';
  return { status, setStatus, isLoading, hasError, isIdle, isSucceeded };
};
